export const phoneNumberFormatter = (phoneNumber: string) => {
  const inputNumber = phoneNumber.replace(/\D/g, '');
  let tempFormattedNumber = '';
  if (inputNumber.length >= 1) {
    tempFormattedNumber += `(${inputNumber.substring(0, 3)}`;
  }
  if (inputNumber.length >= 3) {
    tempFormattedNumber += `) ${inputNumber.substring(3, 6)}`;
  }
  if (inputNumber.length >= 6) {
    tempFormattedNumber += `-${inputNumber.substring(6, 10)}`;
  }

  return tempFormattedNumber;
};

export const reversedPhoneNumberFormatter = (phoneNumber: string) => {
  return phoneNumber.replace(/\D/g, '');
};

export default phoneNumberFormatter;
